"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chart_pyramid = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const chart_pyramid = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'chart-pyramid-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 2C10.2801 2 10.5369 2.15609 10.6658 2.40476L13.1782 7.25H16.25C16.6642 7.25 17 7.58579 17 8C17 8.41421 16.6642 8.75 16.25 8.75H13.9559L17.6658 15.9048C17.7864 16.1373 17.7769 16.4158 17.6409 16.6396C17.5048 16.8634 17.2619 17 17 17H3C2.7381 17 2.49518 16.8634 2.35913 16.6396C2.22309 16.4158 2.21363 16.1373 2.33418 15.9048L6.04406 8.75H3.75C3.33579 8.75 3 8.41421 3 8C3 7.58579 3.33579 7.25 3.75 7.25H6.82184L9.33418 2.40476C9.46312 2.15609 9.71989 2 10 2ZM7.73372 8.75L4.23372 15.5H15.7663L12.2663 8.75H7.73372ZM11.4885 7.25H8.5115L10 4.37931L11.4885 7.25Z', fill: '#4B5563' })));
};
exports.chart_pyramid = chart_pyramid;
